exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authors {\n  margin: 100px 0px;\n}\n\n.author-container > * {\n  width: 50%;\n  padding: 0px 20px;\n}\n\n.author-right > p {\n  margin: 10px 40px;\n  height: 40%;\n  overflow: auto;\n}\n\n.author-left > p {\n  margin: 10px 40px;\n  height: 40%;\n  overflow: auto;\n}\n\n.buttons {\n  padding: 20px 20px;\n  justify-content: space-between;\n  margin: 20px 20px;\n  justify-self: flex-end;\n}\n\n.buttons > * {\n  width: 50%;\n}\n\n.author-container > div > img {\n  width: 100%;\n  height: auto;\n}\n\n.author-container > div > p {\n  text-align: left;\n}\n\n.text-link {\n  color: var(--blue);\n  font-weight: bold;\n}\n\n\n", ""]);

// exports
